import Navbar from "@/components/Navbar";
import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Warehouse from "@/components/Warehouse";
import VisionMission from "@/components/VisionMission";
import Categories from "@/components/Categories";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#faf8f5] text-[#0a192f]">
      <Seo
        title="Dahmani Food | Ingrosso Prodotti Alimentari Halal"
        description="Ingrosso prodotti alimentari halal: spezie, couscous, olio, datteri e specialità etniche per negozi, ristoranti e rivenditori. Forniamo tutta Italia."
        path="/"
      />
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Warehouse />
      <VisionMission />
      <Categories />
      <ContactSection />
      <Footer />
    </div>
  );
}
